<app-whatsapp-button></app-whatsapp-button>
<div class="container">
  <div class="row justify-content-center">
    <div class="col-10 col-lg-10">
      <h1 [innerHTML]="pageTitle">Atendimento - Pagmob</h1>
      <a class="font-weight-bold" [routerLink]="['/app/dashboard']">Voltar</a>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="col-12 col-lg-12">

      <div class="form-panel form-panel-lg" [ng2-loading]="showSpinner" *ngIf="!erro">

        <form (ngSubmit)="f.form.valid && pagar()" class="row" id="formPagamento" name="formPagamento" #f="ngForm">

          <div class="form-group col-lg-6" [ngClass]="{ 'invalid': cpfCard.invalid && cpfCard.touched }">
            <label>CPF do portador do cartão de crédito</label>
            <input type="text" #cpfCard="ngModel" class="form-control" id="cpfCard" name="cpfCard" [(ngModel)]="model.pagamento.cardholdercpf" [textMask]="{mask: cpfmask}" placeholder="___.___.___-__" required>
          </div>

          <div class="form-group col-lg-6" [ngClass]="{ 'invalid': nameCard.invalid && nameCard.touched }">
            <label>Nome no cartão de crédito</label>
            <input type="text" #nameCard="ngModel" class="form-control" id="nameCard" name="nameCard" [(ngModel)]="model.pagamento.cardholdername" required>
          </div>

          <div class="form-group col-lg-6" [ngClass]="{ 'invalid': cardNumber.invalid && cardNumber.touched }">
            <label>Número do cartão de crédito {{ ( cardFlagName ) ? '(' + cardFlagName + ')' : null }}</label>
            <input type="text" #cardNumber="ngModel" class="form-control" id="cardNumber" name="cardNumber" [(ngModel)]="model.pagamento.cardnumber" (ngModelChange)="checkCardFlag($event)" required>
          </div>

          <div class="form-group col-lg-6" [ngClass]="{ 'invalid': cvv.invalid && cvv.touched }">
            <label>CVV do cartão de crédito</label>
            <input type="text" #cvv="ngModel" class="form-control" id="cvv" name="cvv" [(ngModel)]="model.pagamento.cvv" required>
          </div>

          <div class="form-group col-lg-6" [ngClass]="{ 'invalid': expiremonth.invalid && expiremonth.touched }">
            <label>Mês do vencimento do cartão de crédito</label>
            <select class="js-example-basic-single form-control" #expiremonth="ngModel" [(ngModel)]="model.pagamento.expiremonth" id="expiremonth" name="expiremonth" required>
              <option value="01">01</option>
              <option value="02">02</option>
              <option value="03">03</option>
              <option value="04">04</option>
              <option value="05">05</option>
              <option value="06">06</option>
              <option value="07">07</option>
              <option value="08">08</option>
              <option value="09">09</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
            </select>
          </div>

          <div class="form-group col-lg-6" [ngClass]="{ 'invalid': expireyear.invalid && expireyear.touched }">
            <label>Ano do vencimento do cartão de crédito</label>
            <input type="text" #expireyear="ngModel" class="form-control" id="expireyear" name="expireyear" [(ngModel)]="model.pagamento.expireyear" placeholder="20XX" number required>
          </div>

          <div class="form-group col-lg-6" [ngClass]="{ 'invalid': valueToPayFormatted.invalid && valueToPayFormatted.touched }">
            <label>Valor do serviço (R$)</label>
            <input type="text" #valueToPayFormatted="ngModel" class="form-control" id="valueToPayFormatted" name="valueToPayFormatted" [(ngModel)]="dadosPagamento.valueToPayFormatted" disabled>
          </div>
          <div class="form-group col-lg-6" [ngClass]="{ 'invalid': shippingFeeFormatted.invalid && shippingFeeFormatted.touched }">
            <label>Valor do frete (R$)</label>
            <input type="text" #shippingFeeFormatted="ngModel" class="form-control" id="shippingFeeFormatted" name="shippingFeeFormatted" [(ngModel)]="dadosPagamento.shippingFeeFormatted" disabled>
          </div>
          <div class="form-group col-lg-6" [ngClass]="{ 'invalid': shippingFeeFormatted.invalid && shippingFeeFormatted.touched }">
            <label>Valor Total (R$)</label>
            <input type="text" #totalValueFormatted="ngModel" class="form-control" id="totalValueFormatted" name="totalValueFormatted" [(ngModel)]="dadosPagamento.totalValueFormatted" disabled>
          </div>

          <div class="form-group col-lg-12">
            <button type="submit" class="btn btn-primary float-right mb-3">Pagar</button>
          </div>

        </form>
      </div> <!-- /form-panel -->
      <div class="form-panel form-panel-lg" *ngIf="erro">
        <header class="row">
          <div class="col">
            <h2>Ops, ocorreu um problema...</h2>
          </div>
        </header>

        <div>
          <h3>Mensagem: {{ resultado ? resultado.message : '' }} </h3>

        </div>
      </div>
    </div> <!-- /form -->
  </div> <!-- /row -->
</div>
